"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.warehouses = void 0;
var warehousesUrl = '/warehouses';
exports.warehouses = function (axios) {
    return {
        getWarehouses: function (getWarehousesRequest) {
            return axios.get(warehousesUrl, getWarehousesRequest);
        },
        postWarehouses: function (postWarehousesRequest) {
            return axios.post(warehousesUrl, postWarehousesRequest.data);
        },
        deleteWarehousesBulk: function (deleteWarehousesBulkRequest) {
            return axios.delete(warehousesUrl + '/bulk', deleteWarehousesBulkRequest);
        },
        getWarehousesByWarehouseNo: function (getWarehousesByWarehouseNoRequest) {
            return axios.get(warehousesUrl + '/' + getWarehousesByWarehouseNoRequest.params.warehouseNo, getWarehousesByWarehouseNoRequest);
        },
        putWarehousesByWarehouseNo: function (putWarehousesByWarehouseNoRequest) {
            return axios.put(warehousesUrl + '/' + putWarehousesByWarehouseNoRequest.params.warehouseNo, putWarehousesByWarehouseNoRequest.data);
        },
        deleteWarehousesByWarehouseNo: function (deleteWarehousesByWarehouseNoRequest) {
            return axios.delete(warehousesUrl + '/' + deleteWarehousesByWarehouseNoRequest.params.warehouseNo, deleteWarehousesByWarehouseNoRequest);
        }
    };
};
